import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  const footerLinks = {
    [t('footer.services')]: [
      { labelKey: 'footer.svc1', path: '/services' },
      { labelKey: 'footer.svc2', path: '/services' },
      { labelKey: 'footer.svc3', path: '/services' },
      { labelKey: 'footer.svc4', path: '/services' },
      { labelKey: 'footer.svc5', path: '/services' },
      { labelKey: 'footer.svc6', path: '/services' },
    ],
    [t('footer.company')]: [
      { labelKey: 'footer.aboutUs', path: '/about' },
      { labelKey: 'footer.ourPartners', path: '/partners' },
      { labelKey: 'footer.contactUs', path: '/contact' },
      { labelKey: 'nav.news', path: '/news' },
    ],
  };

  return (
    <footer
      className="relative pt-16 lg:pt-20 pb-10 lg:pb-16 overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/3480a37c2973f5a1b76e9f887547f485.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Left-to-right gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-navy/95 via-navy/75 to-navy/40 pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="rounded-2xl p-8 lg:p-12 mb-0">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
            {/* Brand Column */}
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" onClick={handleLinkClick} className="flex items-center gap-3 mb-5 cursor-pointer">
                <img
                  src="https://static.readdy.ai/image/3946f031037e28555363a2e50b79cfcb/2373516416682ca65acc8af1d3a71001.png"
                  alt="MONARU"
                  className="w-10 h-10 object-contain"
                />
                <div>
                  <p className="font-serif font-bold text-white text-sm leading-tight">MONARU</p>
                  <p className="text-[10px] text-white/50 tracking-widest uppercase">Korea · Vietnam</p>
                </div>
              </Link>
              <p className="text-white/70 text-sm font-sans leading-relaxed mb-6">
                {t('footer.tagline')}
              </p>
              <div className="flex items-center gap-3">
                <a href="https://linkedin.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white transition-colors duration-200 cursor-pointer">
                  <i className="ri-linkedin-fill text-sm" />
                </a>
                <a href="https://twitter.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white transition-colors duration-200 cursor-pointer">
                  <i className="ri-twitter-x-fill text-sm" />
                </a>
                <a href="https://youtube.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white transition-colors duration-200 cursor-pointer">
                  <i className="ri-youtube-fill text-sm" />
                </a>
              </div>
            </div>

            {/* Link Columns */}
            {Object.entries(footerLinks).map(([heading, links]) => (
              <div key={heading}>
                <h4 className="text-xs font-sans font-semibold tracking-[0.18em] uppercase text-white mb-5">
                  <a id={`footer-${heading.toLowerCase().replace(/\s+/g, '-')}`} className="cursor-pointer">{heading}</a>
                </h4>
                <ul className="space-y-3">
                  {links.map((link) => (
                    <li key={link.labelKey}>
                      <Link
                        to={link.path}
                        onClick={handleLinkClick}
                        className="text-sm font-sans text-white/60 hover:text-white transition-colors duration-200 cursor-pointer"
                      >
                        {t(link.labelKey)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom Bar */}
          <div className="mt-10 lg:mt-12 pt-6 border-t border-white/15 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs font-sans text-white/50">
              {t('footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
